import { combineReducers } from 'redux';

import liveScoresHeadersReducer from './liveScoresHeadersReducer';
import liveScoresEventsReducer from './liveScoresEventsReducer';
import liveScoresFiltersReducer from './liveScoresFiltersReducer';

export default combineReducers({
  liveScoresHeaders: liveScoresHeadersReducer,
  liveScoresEvents: liveScoresEventsReducer,
  liveScoresFilters: liveScoresFiltersReducer
});
